export default __webpack_public_path__ + "static/media/Weather.4a35d7e6.png";